import { render, staticRenderFns } from "./confirmStep.vue?vue&type=template&id=6f61e4ea&scoped=true"
import script from "./confirmStep.vue?vue&type=script&lang=js"
export * from "./confirmStep.vue?vue&type=script&lang=js"
import style0 from "./confirmStep.vue?vue&type=style&index=0&id=6f61e4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f61e4ea",
  null
  
)

export default component.exports